import type { ScheduleContextInspectorOrder } from '../types'

export interface ContextSidebarEligibilityInput {
  row: ScheduleContextInspectorOrder
  isFollowUpRow: boolean
  isRescheduleMode: boolean
  inFuSession: boolean
  clearedForSidebar: boolean
  hasLocalOrder: boolean
  orderHasFollowUpContext: boolean
  orderIsFuStatus: boolean
  lineIsFollowUp: boolean
  omitFuLineInSchedule: boolean
  omitNonFuLineInFuSession: boolean
  omitMergedMainLine: boolean
}

/** 侧栏以 context target_type 为准；本地订单卡仅用于补充 FU/合并卡等会话规则 */
export function contextRowEligibleForInspectorSidebar(input: ContextSidebarEligibilityInput): boolean {
  const {
    isFollowUpRow,
    isRescheduleMode,
    inFuSession,
    clearedForSidebar,
    hasLocalOrder,
    orderHasFollowUpContext,
    orderIsFuStatus,
    lineIsFollowUp,
    omitFuLineInSchedule,
    omitNonFuLineInFuSession,
    omitMergedMainLine,
  } = input

  if (clearedForSidebar) return false
  if (inFuSession && !isFollowUpRow) return false

  if (inFuSession) {
    if (isFollowUpRow) return true
    if (!lineIsFollowUp) return false
    if (hasLocalOrder && !orderIsFuStatus) return false
    return true
  }

  if (omitFuLineInSchedule) return false
  if (omitNonFuLineInFuSession) return false
  if (omitMergedMainLine) return false

  return true
}

/** 非入口 focus 订单：侧栏只展示，不可点选操作 */
export function inspectorSidebarBlocksNonFocusOrder(
  orderId: string,
  focusOrderId: string | undefined,
  idsReferToSameOrder: (a: string, b: string) => boolean,
): boolean {
  const focus = focusOrderId?.trim()
  const id = orderId?.trim()
  if (!focus || !id) return false
  return !idsReferToSameOrder(id, focus)
}

/** 检查员侧栏订单行是否可点击（仅 focus 订单；FU 页 readonly 行可 view-only） */
export function inspectorSidebarAssignmentClickable(params: {
  orderId: string
  readonly?: boolean
  focusOrderId: string | undefined
  idsReferToSameOrder: (a: string, b: string) => boolean
  allowReadonlyViewOnly: boolean
}): boolean {
  const { orderId, readonly, focusOrderId, idsReferToSameOrder, allowReadonlyViewOnly } = params
  if (inspectorSidebarBlocksNonFocusOrder(orderId, focusOrderId, idsReferToSameOrder)) return false
  if (readonly) return allowReadonlyViewOnly
  return true
}
